/* tslint:disable */

declare var Object: any;
export interface ActivityInterface {
  "empId": string;
  "companyid": number;
  "companycode": string;
  "dateTime": Date;
  "taskDesc"?: string;
  "taskCode"?: string;
  "location": string;
  "id"?: number;
  rel_activityImages?: any[];
}

export class Activity implements ActivityInterface {
  "empId": string;
  "companyid": number;
  "companycode": string;
  "dateTime": Date;
  "taskDesc": string;
  "taskCode": string;
  "location": string;
  "id": number;
  rel_activityImages: any[];
  constructor(data?: ActivityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Activity`.
   */
  public static getModelName() {
    return "Activity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Activity for dynamic purposes.
  **/
  public static factory(data: ActivityInterface): Activity{
    return new Activity(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Activity',
      plural: 'Activities',
      path: 'Activities',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "companyid": {
          name: 'companyid',
          type: 'number'
        },
        "companycode": {
          name: 'companycode',
          type: 'string'
        },
        "dateTime": {
          name: 'dateTime',
          type: 'Date'
        },
        "taskDesc": {
          name: 'taskDesc',
          type: 'string'
        },
        "taskCode": {
          name: 'taskCode',
          type: 'string'
        },
        "location": {
          name: 'location',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        rel_activityImages: {
          name: 'rel_activityImages',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Activity.ts